import { NavLink } from 'react-router-dom';

const SECTIONS_OPERARIO = [
  { slug: "inicio", label: "Inicio", moduloKey: null },
  { slug: "almacen", label: "Almacén", moduloKey: "almacen" },
  { slug: "flota", label: "Flota", moduloKey: "flota" },
  { slug: "appcc", label: "APPCC", moduloKey: "appcc" },
  { slug: "contenedor-sdc", label: "Contenedor SDC", moduloKey: "contenedor_sdc" },
  { slug: "documentos", label: "Documentos", moduloKey: "documentos" },
  { slug: "historial", label: "Historial", moduloKey: "historial" },
  { slug: "inventario-stock", label: "Inventario", moduloKey: "inventario" },
  { slug: "pedidos", label: "Pedidos", moduloKey: "pedidos" },
  { slug: "archivo-internacional", label: "Archivo", moduloKey: "archivo" },
  { slug: "kpis-internacional", label: "KPIs", moduloKey: "kpis" },
  { slug: "facturacion", label: "Facturación", moduloKey: "facturacion" },
];
const VOLDIS_ALMACEN_ID = "cb60fe34-e079-4e36-8bd9-f5f5c3a1f21c";

const SECTIONS_ADMIN = [
  { slug: "pendientes", label: "Pendientes" },
  { slug: "archivo", label: "Archivo" },
  { slug: "descargas", label: "Descargas Operadores" },
  { slug: "kpis", label: "KPIs" },
  { slug: "ajustes", label: "Ajustes" },
  { slug: "inventario", label: "Inventario" },
  { slug: "internacional", label: "Internacional", soloVoldis: true },
];

const labelAdmin = (label, historial) => {
  if (label === "Pendientes") return `📋 Pendientes${historial.length > 0 ? ` (${historial.length})` : ""}`;
  if (label === "Archivo") return "🗂️ Archivo";
  if (label === "Descargas Operadores") return "🚚 Descargas";
  if (label === "Ajustes") return "⚙️ Ajustes";
  if (label === "KPIs") return "📊 KPIs";
  if (label === "Internacional") return "🌍 Internacional";
  return "🏭 Inventario";
};

// ── Nav ──────────────────────────────────────────────────────────
export const Nav = ({ rol, historial, modulos, almacen_id }) => (
  rol !== "operador" && <div className="bg-white border-b px-4 py-2 shadow-sm sticky top-0 z-10">
    <div className="flex gap-2 max-w-2xl mx-auto overflow-x-auto pb-1">
      {(rol === "operario" ? SECTIONS_OPERARIO.filter(s => !s.moduloKey || modulos?.[s.moduloKey] === true) : SECTIONS_ADMIN.filter(s => !s.soloVoldis || almacen_id === VOLDIS_ALMACEN_ID)).map(({ slug, label }) => (
        <NavLink
          key={slug}
          to={`/app/home/${slug}`}
          className={({ isActive }) => `px-3 py-2 text-xs font-semibold rounded-lg transition-all whitespace-nowrap ${isActive ? (rol === "operario" ? "bg-blue-600 text-white shadow" : "bg-green-600 text-white shadow") : `bg-white text-gray-600 ${rol === "operario" ? "hover:bg-blue-50" : "hover:bg-green-50"} border border-gray-200`}`}
        >
          {rol === "operario" ? label : labelAdmin(label, historial)}
        </NavLink>
      ))}
    </div>
  </div>
);
